import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

enum THEME {
    Light = 'light',
    Dark = 'dark'
}

@Component({
    selector: 'app-theme-switcher',
    standalone: true,
    templateUrl: './theme-switcher.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ThemeSwitcherComponent implements OnInit {
    public showLabel = input<boolean>(false);

    protected currentTheme = signal<THEME>(THEME.Light);

    protected themeIcon = computed(() => (this.currentTheme() === THEME.Light ? 'windowing' : 'brightness'));
    protected themeTextKey = computed(() =>
        this.currentTheme() === THEME.Light ? 'common.header.theme-switcher.light' : 'common.header.theme-switcher.dark'
    );
    protected actionThemeKey = computed(() =>
        this.currentTheme() === THEME.Light ? 'common.header.theme-switcher.light' : 'common.header.theme-switcher.dark'
    );

    private static readonly STORAGE_KEY = 'app-theme';

    public ngOnInit(): void {
        const saved = localStorage.getItem(ThemeSwitcherComponent.STORAGE_KEY) as THEME | null;
        const initial = saved ?? (document.documentElement.getAttribute('theme') as THEME) ?? THEME.Light;
        this.applyTheme(initial === THEME.Light ? THEME.Light : THEME.Dark);
    }

    public toggleTheme(): void {
        const nextTheme: THEME = this.currentTheme() === THEME.Light ? THEME.Dark : THEME.Light;
        this.applyTheme(nextTheme);
    }

    private applyTheme(theme: THEME): void {
        if (typeof document !== 'undefined') {
            document.documentElement.setAttribute('theme', theme);
            document.documentElement.classList.toggle('dark', theme === THEME.Dark);
        }

        localStorage.setItem(ThemeSwitcherComponent.STORAGE_KEY, theme);
        this.currentTheme.set(theme);
    }
}
